import {useQuery, UseQueryResult} from 'react-query'
import {api} from '../../../App.global'
import {ADDRESS_QUERY_STALE_TIME_MS, MIN_ADDRESS_SEARCH_LENGTH} from '../constants'

export type SearchAddressParams = {
  searchText: string
  country: string
  maxSuggestions?: number
}

export type Suggestion = {
  text: string
  magicKey: string
}

type SearchAddressResponse = {
  suggestions: Suggestion[]
}
export const searchAddress = async (
  params: SearchAddressParams
): Promise<SearchAddressResponse> => {
  const config = {params}
  const response = await api.get('/address/search', config)
  const {data} = response
  return data
}

export const useSearchAddress = (
  params: SearchAddressParams
): UseQueryResult<SearchAddressResponse, Error> => {
  const queryKey = [
    'searchAddress',
    {
      ...params
    }
  ]
  const queryOptions = {
    staleTime: ADDRESS_QUERY_STALE_TIME_MS,
    cacheTime: ADDRESS_QUERY_STALE_TIME_MS,
    enabled: params.searchText.length >= MIN_ADDRESS_SEARCH_LENGTH
  }

  const queryInfo = useQuery<SearchAddressResponse, Error>(
    queryKey,
    () => searchAddress(params),
    queryOptions
  )
  return queryInfo
}
